import modSchemaMixin from "@/mixins/sheet/base/modSchemaMixin.js";
import sheetCalcuMixin from "@/mixins/sheet/base/sheetCalcuMixin.js";
import shareBtnMixin from "@/mixins/sheet/operation/shareBtnMixin.js";
import customBtnMixin from "@/mixins/custom/operation/customBtnMixin.js";
import sheetPrintModalRenderMixin from "@/views/menu/sheet/operation/sheetPrintModalRenderMixin.js";
import sheetGroups from "@/views/menu/sheet/attach/sheetGroups.vue";
import sheetLogs from "@/views/menu/sheet/attach/sheetLogs.vue";
import sheetIframe from "@/views/menu/sheet/attach/sheetIframe.vue";
import sheetExtra from "@/views/menu/sheet/attach/sheetExtra.vue";

export default {
    mixins: [
        modSchemaMixin,
        sheetCalcuMixin,
        shareBtnMixin,
        customBtnMixin,
        sheetPrintModalRenderMixin
    ],
    components: {
        sheetGroups,
        sheetLogs,
        sheetIframe,
        sheetExtra
    },
    inject: ["appObj"],
    provide () {
        return {
            companyId: this.companyId,
            appId: this.appId
        };
    },
    props: {
        appId: String
    },
    data () {
        return {
            companyId: this.$store.getters.companyId,
            sign: false,

            showForm: false,
            formData: {},
            groupKey: "",

            otherGroups: [
                {
                    key: "log",
                    name: "操作日志",
                    event: "showLogs"
                }
            ],
            showSheetLogs: false,

            showIframe: false,
            currentIframe: null,

            showPrintModal: false, // 打印弹框及配置
            showPrintModalPropsObj: {
                title: "预览打印内容",
                maskClosable: false,
                footerHide: true
            },

            // 执行状态
            runState: 0
        };
    },
    computed: {
        urlParams () {
            return {
                module: "sheet",
                name: "index"
            };
        },
        editMode () {
            if (this.editType === "task") {
                return this.editType;
            } else {
                return this.layout;
            }
        },
        layout () {
            return this.appObj ? this.appObj.layout || "creative" : "creative";
        },
        printObj () {
            // 打印内容配置
            return {
                id: "sheetUpdatePrintContent",
                popTitle: this.modName
            };
        },

        customBtnObj () {
            return {
                btnType: "default",
                size: "large"
            };
        },
        allOperationMap () {
            return {
                ...this.baseOperationMap,
                ...this.customOperationMap,

                close: {
                    name: "关闭",
                    type: "close",
                    size: 24,
                    icon: "md-close",
                    event: "clickCancel"
                },

                save: {
                    name: "保存",
                    type: "save",
                    btnType: "primary",
                    size: "large",
                    style: "width: 150px;",
                    event: "clickSave"
                },
                cancel: {
                    name: "取消",
                    type: "cancel",
                    size: "large",
                    style: "width: 150px;",
                    event: "clickCancel"
                },
                back: {
                    name: "返回",
                    type: "back",
                    btnType: "primary",
                    size: "large",
                    event: "clickBack"
                }
            };
        },
        operationMap () {
            let filterBtnArr = [];
            if (this.canEdit) {
                // 编辑状态过滤发起流程按钮
                filterBtnArr.push(...this.customDataBtns);
            } else {
                filterBtnArr.push("save");
            }
            return this.$categoryMapToMap(
                this.allOperationMap,
                undefined,
                filterBtnArr
            );
        },
        customGroups () {
            if (this.modKey === "DBM_Firm") {
                return [
                    {
                        _key: "country",
                        name: "区域图",
                        url: "http://bridata.com/firm/country_iframe",
                        event: "showIframe"
                    },
                    {
                        _key: "footmark",
                        name: "足迹图",
                        url: "http://bridata.com/firm/footmark_iframe",
                        event: "showIframe"
                    },
                    {
                        _key: "relation",
                        name: "关系图",
                        url: "http://bridata.com/firm/relation_iframe",
                        event: "showIframe"
                    },
                    {
                        _key: "projects",
                        name: "项目清单",
                        url: "http://bridata.com/firm/projects_iframe",
                        event: "showIframe"
                    }
                ];
            } else {
                return [];
            }
        }
    },
    created () {
        this.sheetUpdateInit();
    },
    methods: {
        // 初始化
        sheetUpdateInit () {
            Object.assign(this.formData, {
                _id: this.dataId
            });
            // 请求默认值 or show接口
            this.getData(this.isCreate ? "default" : "show");
        },
        getModAfter () {
            setTimeout(() => {
                this.showForm = true;
                if (this.editType == "standOut") {
                    this.groupKey = this.curScreenGroups[1]._key;
                } else {
                    this.groupKey = this.curScreenGroups[0]._key;
                }

                this.runState++;
                this.runState == 2 && this.formDataCreateInit();
            }, 0);
        },

        /* ------------- 接口和工具方法 ------------ */
        // 接口 -获取数据
        getData (name) {
            this.$https({
                url: {
                    ...this.urlParams,
                    name
                },
                params: {
                    _id: this.dataId,
                    screenKey: this.screenKey
                },
                callback: (data) => {
                    this.formData = {
                        ...this.formData,
                        ...data
                    };
                    if (this.isCreate) {
                        Object.assign(this.formData, this.defaultFormData);
                    }

                    this.runState++;
                    this.runState == 2 && this.formDataCreateInit();
                }
            });
        },
        // 接口 -添加数据
        handleCreate (callback) {
            this.$https({
                url: {
                    ...this.urlParams,
                    name: "create"
                },
                messageTip: "添加成功！",
                params: {
                    ...this.formData,
                    screenKey: this.screenKey
                },
                callback: (data) => {
                    this.sign = false;
                    callback ? callback() : this.createCb(data);
                }
            });
        },
        // 接口 -编辑数据
        handleUpdate (callback) {
            this.$https({
                url: {
                    ...this.urlParams,
                    name: "update"
                },
                messageTip: "修改成功！",
                params: {
                    ...this.formData,
                    screenKey: this.screenKey
                },
                callback: (data) => {
                    this.sign = false;
                    callback ? callback() : this.updateCb(data);
                }
            });
        },

        // 点击分组
        selectGroup (val) {
            this.groupKey = val._key;
            this.showSheetLogs = false;
            this.showIframe = false;
            this.showForm = false;
            this.$nextTick(() => {
                this.showForm = true;
            });
        },
        // 点击切换自定义分组
        customSelectGroup (val) {
            this.currentIframe = val;
            this.showSheetLogs = false;
            this.showForm = false;
            this.showIframe = false;
            this.$nextTick(() => {
                this.showIframe = true;
            });
        },
        // 点击保存
        clickSave () {
            this.$refs.form.$refs.form.validate((valid) => {
                if (valid) {
                    this.isCreate ? this.handleCreate() : this.handleUpdate();
                } else {
                    this.$formRulesWarning();
                }
            });
        },
        // 回调 -控件change
        change (formItem, ...params) {
            this.sign = true;
            this.relatedChange(formItem, ...params);

            // 向Iframe 层级传输信息
            window.parent.postMessage(
                {
                    status: "success",
                    type: "judgeJump",
                    sign: true
                },
                "*"
            );
        },

        showLogs () {
            this.showForm = false;
            this.showIframe = false;
            this.showSheetLogs = true;
            if (this.editType !== "standOut") {
                this.$refs.sheetGroups.value = undefined;
            }
        },

        clickBack () {
            if (this.editType !== "standOut") {
                this.$refs.sheetGroups.value = this.groupKey;
            }
            this.changeShowContent();
        },
        // 切换展示表单/操作日志
        changeShowContent () {
            this.showSheetLogs = false;
            this.showForm = false;
            this.showIframe = false;
            this.$nextTick(() => {
                this.showForm = true;
            });
        }
    }
};



// WEBPACK FOOTER //
// ./src/views/menu/sheet/operation/update/sheetUpdateMixin.js